import { ReviewFilterCategory } from '../Stores/filtersStore';

export type NormalizedFilterType =
  | 'content_type'
  | 'ratings'
  | 'variant'
  | 'shop';

const normalizationMap: Partial<
  Record<ReviewFilterCategory, NormalizedFilterType>
> = {
  contentTypes: 'content_type',
  rating: 'ratings',
  variants: 'variant',
  shops: 'shop',
};

export const normalizeCategory = (
  category: ReviewFilterCategory | string
): NormalizedFilterType | undefined =>
  normalizationMap[category as ReviewFilterCategory];
